import { useCallback } from 'react'

import {
  useDraftWithdrawToParentActions,
  useWithdrawToParent,
} from 'app/dataProviders/cafeteria/compensation/withdraw/toParent/hooks'

import usePopup from 'app/common/hooks/usePopup'
import { Params, ParamsNew } from 'app/dataTypes/cafeteria/compensation/withdraw/toParent'

import { ControlValues } from './controls'
import { WithdrawToParentForm } from './WithdrawToParentForm'
import { AgreementMessage } from './AgreementMessage'


type Props = {
  studentID: string
  supplierID: string
  withdrawID: string | null
  returnToRoot: () => void
  route: any
}

export const WithdrawToParent = ({
  studentID,
  supplierID,
  withdrawID: editWithdrawID,
  returnToRoot,
  route,
}: Props) => {
  const popup = usePopup()

  const params: Params | ParamsNew = (
    editWithdrawID
      ? { withdrawID: editWithdrawID }
      : { studentID, supplierID }
  )
  const { data, loading, error } = useWithdrawToParent({ params })

  const {
    withdraw: { withdrawID: newWithdrawID },
    createDraft,
    updateDraft,
    sendDraft,
    downloadDraft,
  } = useDraftWithdrawToParentActions()

  const withdrawID = editWithdrawID || newWithdrawID

  const onNewDraft = useCallback(async (controlValues: ControlValues) => {
    if (data) {
      const { availableWithdrawValue: value } = data
      const res = await createDraft({ studentID, supplierID, value, ...controlValues })
      return res
    }
    return null
  }, [data, createDraft, studentID, supplierID])

  const onUpdateDraft = useCallback(async (controlValues: ControlValues) => {
    if (data && withdrawID) {
      const { availableWithdrawValue: value } = data
      const res = await updateDraft({ withdrawID, value, ...controlValues })
      return res
    }
    return false
  }, [data, updateDraft, withdrawID])

  const onSendDraft = useCallback(async () => {
    if (data && withdrawID) {
      const res = await sendDraft({ withdrawID })
      return res
    }
    return false
  }, [data, sendDraft, withdrawID])

  const onDownloadDraft = useCallback(async () => {
    if (withdrawID) {
      const res = downloadDraft({ withdrawID })
      return res
    }
    popup('Не удалось скачать файл, отсутствует идентификатор')
    return false
  }, [withdrawID, downloadDraft, popup])

  return (
    <WithdrawToParentForm
      withdrawID={withdrawID}
      withdrawData={data}
      loading={loading}
      returnToRoot={returnToRoot}
      onNewDraft={onNewDraft}
      onUpdateDraft={onUpdateDraft}
      onSendDraft={onSendDraft}
      onDownloadDraft={onDownloadDraft}
      route={route}
      errorExplanation={error}
      agreement={
        <AgreementMessage
          supplierID={supplierID}
          studentID={studentID}
        />
      }
    />
  )
}
